import SET_AUTHORIZATION from 'Root/App/Contexts/Authorizations/SlideContainer/Row/Authorization/LevelButton/set-authorization.graphql'

import { useContext } from 'react'

import classNames from 'classnames'

import { useMutation } from '@apollo/client'
import Button from 'Root/App/Button'
import { WithContentsContext } from 'Root/Contexts/with-contents-context'
import { useCurrentUserId } from 'lib/use-current-user-id'
import { useRouter } from 'next/router'

interface RegistrateForContentsProps {
  elementId: string
  children?: React.ReactNode
  className?: string
}

const RegistrateForContents = ({
  elementId,
  children,
  className = '',
}: RegistrateForContentsProps) => {
  const router = useRouter()
  const currentUserId = useCurrentUserId()
  const [setAuthorization, { loading }] = useMutation(SET_AUTHORIZATION)
  const { setWithContents } = useContext(WithContentsContext)

  const handleClick = async () => {
    if (currentUserId) {
      await setAuthorization({
        variables: {
          object: elementId,
          user: currentUserId,
          value: 1,
        },
      })

      if (setWithContents) {
        setWithContents(true)
      }

      return
    }

    router.push(`/need_registration${router.asPath}`)
  }

  return (
    <Button
      onClick={handleClick}
      disabled={loading}
      className={classNames([className, 'max-w-max h-auto py-2 px-3'])}
    >
      {children}
    </Button>
  )
}

export default RegistrateForContents
